import { render, staticRenderFns } from "./amendantRecord.vue?vue&type=template&id=779baae9&scoped=true"
import script from "./amendantRecord.vue?vue&type=script&lang=js"
export * from "./amendantRecord.vue?vue&type=script&lang=js"
import style0 from "./amendantRecord.vue?vue&type=style&index=0&id=779baae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779baae9",
  null
  
)

export default component.exports